const Paragraph = ({ content }) => (
    <div className="container-fluid p-3 mb-5">
      <p className="lead text-center">{content}</p>
    </div>
  );
  
  export default Paragraph;